
import React from 'react'
import FLEnvironment from '../Images/Florida-Environmental-Outreach-Magazine.jpg'
import Button from '@mui/material/Button';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { createTheme, ThemeProvider } from "@mui/material/styles";


const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});


export default function FloridaEnvironmentalOutreach() {
  return (
    <div className='bg-white p-20 '>
      <div><img className='rounded-3xl mx-auto' src={FLEnvironment} alt='' title='' /></div>
      <div className='pt-5'><div className="pb-5">Published quarterly, Florida Environmental Outreach Magazine is a full-color publication full of environmental news, current research, and National Save the Sea Turtle Foundation updates. A sure hit with readers of all ages! If you have an interesting topic or project you&apos;d like our readers to know about, contact the Editorial Team at the National Save the Sea Turtle Foundation to discuss your topic or submit an article.</div></div>



      <div><div className="pb-5">To get your own copies delivered straight to your home, sign up for your subscription at</div></div>

      <div className='mb-5 clear-both'>
        <ThemeProvider theme={theme}>
          <Button href="https://savetheseaturtle.org/Forms/FLOutreachMagazin.html" style={{ color: '#ffffff' }} color="secondary" rel='noreferrer noopener' variant="contained" endIcon={<DriveFileRenameOutlineIcon />} className='mx-auto'>
            Outreach Subscription
          </Button>
        </ThemeProvider></div>

    </div>
  )
}

